import { ActivityCategoryInfo, MatchRoundScheduleConfig } from "../../interface";
import { categoryHasBronzeMatch } from "./categorySetupUtils";

export const getUniqueScheduledCourts = (
    schedules: MatchRoundScheduleConfig[]
): number[] => Array.from(new Set(schedules.map(schedule => schedule.court)))
    .sort((left, right) => left - right);

export function canIncludeBracketClassification(
    category?: Pick<ActivityCategoryInfo, 'options'> | null,
): boolean {
    if (!category) {
        return false;
    }
    return categoryHasBronzeMatch(category.options?.bracket_structure);
}

export function categoryHasDownloadableMatches(
    category?: Pick<ActivityCategoryInfo, 'is_bracket_done'> | null,
): boolean {
    return Boolean(category?.is_bracket_done);
}

export function downloadUnavailableCopy(
    category?: Pick<ActivityCategoryInfo, 'is_setup_done' | 'is_bracket_done'> | null,
): { title: string; detail?: string } | null {
    if (!category) {
        return { title: 'Select a category to download PDFs.' };
    }
    if (categoryHasDownloadableMatches(category)) {
        return null;
    }
    return {
        title: 'This category is not configured yet.',
        detail: 'Finish category setup and publish the bracket before downloading PDFs.',
    };
}
